export const TIMEZONES = [
  { value: 'America/New_York', label: 'Eastern Time (ET)' },
  { value: 'America/Chicago', label: 'Central Time (CT)' },
  { value: 'America/Denver', label: 'Mountain Time (MT)' },
  { value: 'America/Phoenix', label: 'Mountain Time - Arizona (MT)' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
  { value: 'America/Anchorage', label: 'Alaska Time (AKT)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time (HT)' }
];

export const REMINDER_CHANNELS = [
  { value: 'email', label: 'Email' },
  { value: 'discord', label: 'Discord' },
  { value: 'app', label: 'In-App' }
];

export const PICKSLIP_BEHAVIORS = [
  { value: 'peek', label: 'Peek Mode' },
  { value: 'nothing', label: 'Hide All' },
  { value: 'open', label: 'Always Open' }
]; 